import { render, staticRenderFns } from "./not-arrival-to-reorder.vue?vue&type=template&id=39ed832a&scoped=true"
import script from "./not-arrival-to-reorder.vue?vue&type=script&lang=js"
export * from "./not-arrival-to-reorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ed832a",
  null
  
)

export default component.exports